import React from 'react'
import { NavLink } from 'react-router-dom'
function FooterLinkComponent({data}) {
    const activeStyle={
        cursor:"pointer",
        color: "grey",
        textDecoration: "none",
    }
    const baseStyle={
      color: "grey",
      textDecoration: "none",
    }
  return (
    <>
         {data.map((link)=>(
            <p style={{fontSize:"15px"}}><NavLink 
              style={({isActive}) => (isActive ? activeStyle: baseStyle)}
              key={link.title} to={link.to}>
                {link.title}
            </NavLink></p> 
          ))}
    </>
  )
}

export default FooterLinkComponent